import { AutogenModelEdiDataRule, AutogenRowEdiDataRule } from "./autogen/AutogenModelEdiDataRule";

export class ModelEdiDataRule extends AutogenModelEdiDataRule<RowEdiDataRule> {
	constructor() {
		super(RowEdiDataRule);
	}
}

export class RowEdiDataRule extends AutogenRowEdiDataRule {
}